import { IGetPublishTermsResponseData, ITermSchema } from '../internalTypes';
import { getServiceId } from './getServiceId';

export function getAuctionTerm(data: IGetPublishTermsResponseData): ITermSchema | null {
  const { terms } = data;

  if (!terms) {
    return null;
  }

  const auctionTerm = terms.find(term => getServiceId(term) === 'auction');

  return auctionTerm || null;
}
